var exports = {
  "c1": "mainChart__y8AsR1",
  "DD": "title__7vD5Ut",
  "VA": "subtitle__YaV8Rn",
};

module.exports = exports;
